import { Link } from 'react-router-dom'

import { EllipsisVertical, Plus } from 'lucide-react'
import { Button, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from 'twyne-new.ui'

import { useGrid } from '@Components/Grid/context'

import AddButton, { useGridBasePath } from "./AddButton"
import RefreshButton from "./RefreshButton"

export { AddButton, RefreshButton as Refresh }

export default function DefaultActions({ refresh = <RefreshButton />, add = <AddButton />, menu, children }) {
  return <Wrapper>
    {refresh}
    <div className={menu ? 'hidden md:contents' : 'contents'}>
      {children}
      {add}
    </div>
    {menu ? <ActionsMenu items={menu} withAdd={add !== null} /> : null}
  </Wrapper>
}

function ActionsMenu({ items, withAdd }) {
  const { definitions: { entityName } } = useGrid()
  const path = useGridBasePath()
  const allItems = withAdd ? [{ label: `Add ${entityName}`, icon: Plus, to: `${path}/add` }, ...items] : items

  return <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button color='accent' className='md:hidden'>
        <EllipsisVertical size={14} />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align='end'>
      {allItems.map(({ label, icon, to, onSelect }) => to ? <Link key={label} to={to}>
        <DropdownMenuItem icon={icon}>{label}</DropdownMenuItem>
      </Link> : <DropdownMenuItem key={label} icon={icon} onSelect={onSelect}>
        {label}
      </DropdownMenuItem>)}
    </DropdownMenuContent>
  </DropdownMenu>
}

export function Wrapper({ children }) {
  return <div className="flex gap-4 max-md:gap-2">
    {children}
  </div>
}
